import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex px-2 py-1 shadow border rounded-lg hover:bg-gray-100" }
const _hoisted_2 = { class: "bg-gray-800 text-white rounded-full h-12 w-12 pt-3 text-align-center" }
const _hoisted_3 = { class: "p-3" }

import {computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EmployeeButton',
  props: {
  firstName:String
},
  setup(__props) {

const props = __props;



// a computed ref
const computedLetter = computed(() => {
return props.firstName[0];
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(computedLetter.value), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.firstName), 1)
    ])
  ]))
}
}

})